import { render } from "./Lens.vue?vue&type=template&id=845cd8c4"
import script from "./Lens.vue?vue&type=script&lang=js"
export * from "./Lens.vue?vue&type=script&lang=js"

import exportComponent from "/Users/viktor/Desktop/projects/u2c/x5-group/mission-accomplished/backend/project/packages/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Lens.vue"]])

export default __exports__